<button style="margin-left: 10px;"  mdc-switch selected.bind="globalObjectInstance.autoSave" click.trigger="toggle()"></button>
<label style="margin-right: 10px;">Autosave</label>